import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal as ModalPrimitive } from './ui';

const Modal = ({ isOpen, onClose, title, children }) => {
  return (
    <ModalPrimitive
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      footer={
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      }
      size="xl"
    >
      {children}
    </ModalPrimitive>
  );
};
Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default Modal;
